import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import "./documentViewer.css";
import { atom, useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import ApplicationService from "@mirage/services/ApplicationService";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import useSessionStorage, { ISessionStorageMap } from "@mirage/hooks/useSessionStorage";
export interface HorizonMessage {
    Method: string;
    Argument: any;
}
export interface DocumentViewerProps {
    editable?: boolean;
    appName: keyof ISessionStorageMap;
}
export interface DocumentViewerState {
    isVisible: boolean;
    attachmentIds: number[];
    onClose?: () => void;
}
export const documentViewerRecoilState = atom({
    key: "documentViewerState",
    default: { isVisible: false, attachmentIds: [] } as DocumentViewerState,
});

let horizonContentWindow: Window | null = null;
export const DocumentViewer: React.FC<DocumentViewerProps> = ({ appName, editable }) => {
    const [state, setState] = useRecoilState(documentViewerRecoilState);
    const locationHash = useLocation().hash;
    const hashMatch = locationHash === "#viewDocument";
    const applicationService = new ApplicationService();
    const [sessionValue] = useSessionStorage(appName);
    const { clientSettings } = sessionValue;

    useEffect(() => {
        const attachmentsExist = state.attachmentIds.length > 0;
        const visible = attachmentsExist && hashMatch;
        setVisible(visible);
        if (attachmentsExist) {
            const message = { Method: "OpenAttachment", Argument: { AttachmentIds: state.attachmentIds, UserId: 0, HideDetach: true, UserName: "" } };
            const user = applicationService.getLoggedInUser();
            if (user && editable) {
                message.Argument.UserId = user.id;
                message.Argument.UserName = (user.first_name as string) + " " + (user.last_name as string);
            }
            postMessage(message);
        }
    }, [state.attachmentIds, locationHash]);
    function postMessage(message: HorizonMessage) {
        if (horizonContentWindow) {
            horizonContentWindow.postMessage(message, "*");
        } else {
            console.error("no iframe content window found " + message);
        }
    }
    function onIframeLoaded(e: any) {
        horizonContentWindow = e.target.contentWindow;
    }
    function setVisible(isVisible: boolean) {
        setState((old) => {
            return { ...old, isVisible: isVisible };
        });
    }
    function setAttachmentIds(attachmentIds: number[]) {
        setState((old) => {
            return { ...old, attachmentIds: attachmentIds };
        });
    }
    function onCloseDocumentViewerClicked() {
        history.back();
        setAttachmentIds([]);
        if (typeof state.onClose === "function") {
            state.onClose();
        }
    }
    const ref = useRef<HTMLIFrameElement>() as React.MutableRefObject<HTMLIFrameElement>;

    const className = "documentViewer " + (state.isVisible ? "documentViewer--visible" : "");

    return (
        <div className={className}>
            <span onClick={onCloseDocumentViewerClicked} className="documentViewer__closeIcon">
                <FontAwesomeIcon icon={faXmark} style={MirageTheme.icons.sizeS} />
            </span>
            <iframe
                onLoad={(e) => onIframeLoaded(e)}
                ref={ref}
                src={clientSettings?.DOCUMENT_VIEWER_URL}
                width="100%"
                height="100%"
                sandbox="allow-same-origin allow-scripts"
            ></iframe>
        </div>
    );
};
